import { setColors } from './custom_color';
import { setTheme } from '../skins-utils';

let $currentThemeName = '';
function loadTheme(themeName) {
  switch (themeName) {
    case 'theme_default_red':
      return import('./theme-default-red').then(module => module.default);
    case 'theme_default_white':
      return import('./theme-default-white').then(module => module.default);
    case 'theme_default_blue':
      return import('./theme-default-blue').then(module => module.default);
    case 'theme_default_golden':
      return import('./theme-default-golden').then(module => module.default);
    case 'theme_default_black':
      return import('./theme-default-black').then(module => module.default);

    case 'theme_fashion_red':
      return import('./theme-fashion-red').then(module => module.default);
    case 'theme_fashion_white':
      return import('./theme-fashion-white').then(module => module.default);
    case 'theme_fashion_blue':
      return import('./theme-fashion-blue').then(module => module.default);
    case 'theme_fashion_black':
      return import('./theme-fashion-black').then(module => module.default);
    case 'theme_fashion_golden':
      return import('./theme-fashion-golden').then(module => module.default);

    case 'theme_simple_red':
      return import('./theme-simple-red').then(module => module.default);
    case 'theme_simple_white':
      return import('./theme-simple-white').then(module => module.default);
    case 'theme_simple_blue':
      return import('./theme-simple-blue').then(module => module.default);
    case 'theme_simple_black':
      return import('./theme-simple-black').then(module => module.default);
    case 'theme_simple_golden':
      return import('./theme-simple-golden').then(module => module.default);

    // cms
    case 'theme_main_default_cms':
      return import('./theme-main-default-cms').then(module => module.default);
    case 'theme_main_dark_cms':
      return import('./theme-main-dark-cms').then(module => module.default);

    // 大会
    case 'theme_meeting_dark':
      return import('./theme-meeting-dark').then(module => module.default);
    case 'theme_meeting_default':
      return import('./theme-meeting-default').then(module => module.default);

    default:
      throw new Error(`Unknown theme: ${themeName}`);
  }
}

async function applyTheme(themeName) {
  $currentThemeName = themeName;
  const theme = await loadTheme(themeName);
  setTheme(theme);
}

async function setColor(color, theme) {
  const currentTheme = await loadTheme(theme);
  return Object.assign(currentTheme, setColors(color));
}

export async function getCurrentTheme() {
  const theme = await loadTheme($currentThemeName);
  return theme;
}

export async function getCurrentThemeColor() {
  const theme = await loadTheme($currentThemeName);
  return theme['--theme-color'];
}

export default {
  $currentThemeName,
  setColor,
  applyTheme,
  getCurrentThemeColor
};
